import React, { useEffect, useState } from "react";
import SectionCard from "../SectionCard/SectionCard";
import { ArrowRight, ArrowRightFromLine, Codepen } from "lucide-react";
import { Separator } from "Components/ui/separator";
import ProfitCard from "../ProfitCard/ProfitCard";
import UseInnerWidth from "hooks/UseInnerWidth";
import DepositPopup from "Pages/Profile/ProfileComponents/Wallet/WalletComponents/DepositPopup/DepositPopup";
import WithdrawPopup from "Pages/Profile/ProfileComponents/Wallet/WalletComponents/WithdrawPopup/WithdrawPopup";
import { useNavigate } from "react-router-dom";
import { getLiveChallenges } from "../../../../Redux/Profile/ProfileActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { useAuth } from "@clerk/clerk-react";
import { Skeleton } from "Components/ui/skeleton";
function SecondSec() {
  const width = UseInnerWidth();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getToken } = useAuth();

  const [openDepositPopup, setOpenDepositPopup] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState();
  const [depositAmount, setDepositAmount] = useState();
  const [openWithdrawPopup, setOpenWithdrawPopup] = useState(false);
  const [selectedWithdrawCurrency, setSelectedWithdrawCurrency] =
    useState("usd");
  const [withdrawAmount, setWithdrawAmount] = useState();
  const [selectedWithdrawMethod, setSelectedWithdrawMethod] = useState();

  useEffect(() => {
    dispatch(getLiveChallenges(getToken));
  }, []);

  const { liveChallenges } = useSelector((state) => state.ProfileReducer);
  const { getChallengeInfoLoading, getChallengesLoading, challengeInfo } =
    useSelector((state) => state.challengeMainReducer);

  return (
    <div
      className={`flex-1 h-full flex flex-col hideScrollBar ${
        width > 600 ? "max-h-[30rem] overflow-auto  " : "h-full mb-4"
      } `}
    >
      <div className="flex flex-col gap-3">
        <SectionCard
          icon={<Codepen color="var(--primary)" />}
          title={"New Challenge"}
          letter={"N"}
          onClick={() => {
            navigate("/landing");
          }}
        />
        <SectionCard
          icon={<ArrowRight color="#7AB5D2" />}
          title={"Transfer To Wallet"}
          letter={"T"}
          onClick={() => {
            if (liveChallenges?.length > 0) {
              setOpenDepositPopup(true);
            } else {
              toast.error("No Live Challenges Found!", {
                autoClose: 2000,
                className: "bg-red-opacity text-red",
              });
            }
          }}
        />
        <SectionCard
          icon={<ArrowRightFromLine color="#83CE94" />}
          title={"Withdraw"}
          letter={"W"}
          onClick={() => {
            setOpenWithdrawPopup(true);
          }}
        />
        <DepositPopup
          open={openDepositPopup}
          setOpen={setOpenDepositPopup}
          selected={selectedDeposit}
          setSelected={(selected) => {
            setSelectedDeposit(selected);
          }}
          value={depositAmount}
          setValue={setDepositAmount}
        />

        <WithdrawPopup
          open={openWithdrawPopup}
          setOpen={setOpenWithdrawPopup}
          currencies={selectedWithdrawCurrency}
          setCurrencies={setSelectedWithdrawCurrency}
          selectedMethod={selectedWithdrawMethod}
          setSelectedMethod={setSelectedWithdrawMethod}
          value={withdrawAmount}
          setValue={setWithdrawAmount}
        />
      </div>
      <Separator className="bg-border-darkNew my-8 h-[0.1rem]" />
      <div className="h-full  ">
        <div className="text-sm text-white-opacity mb-4">PROFIT GOALS</div>
        {getChallengeInfoLoading || getChallengesLoading ? (
          <div className="space-y-4">
            {/* Repeat the skeleton twice */}
            {[0, 1].map((index) => (
              <div
                key={index}
                className="border border-border-darkNew bg-transparent rounded-lg p-4"
              >
                <div className="space-y-3">
                  {/* Header and amount row */}
                  <div className="flex justify-between items-start">
                    <div className="space-y-2">
                      <Skeleton className="h-6 w-[80px]" /> {/* Phase 2 */}
                      <Skeleton className="h-4 w-[100px]" />{" "}
                      {/* Profit target text */}
                    </div>
                    <Skeleton className="h-8 w-[120px]" /> {/* Amount */}
                  </div>

                  {/* Progress bar */}
                  <Skeleton className="h-1 w-full" />
                </div>
              </div>
            ))}
          </div>
        ) : challengeInfo?.profitGaols?.length > 0 ? (
          <div className="flex flex-col gap-3">
            {challengeInfo?.profitGaols?.map((item, index) => {
              return (
                <ProfitCard
                  percentage={item?.percentage}
                  balance={item?.balance}
                  target={item?.target}
                  stage={item?.stage}
                />
              );
            })}
          </div>
        ) : (
          <div className="text-base bg-background rounded-lg border-border-darkNew p-4 border-2 text-white-opacity h-full flex flex-col gap-0 items-center justify-center cursor-pointer ">
            <div className="font-N_Medium text-2xl ">No Goals yet!</div>
            <div className="font-N_Light text-base w-full max-w-[18rem]  text-center">
              Create a new challenge to set profit goals.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default SecondSec;
